var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"againTicketPurchase"},[_c('div',{staticClass:"order",on:{"click":_vm.orderClick}},[_vm._v("Enter order list")]),_c('div',{staticClass:"again",on:{"click":_vm.againBuyingTickets}},[_vm._v("Book the ticket again")])])
}
var staticRenderFns = []

export { render, staticRenderFns }